/**
 * 业务线状态管理模块
 *
 * 当前业务线影响所有 API 请求的路径前缀
 * 持久化到 localStorage，刷新后保持上次选择的业务线
 */
import { create } from 'zustand'

/* ============================================
 * 常量
 * ============================================ */

const BIZ_LINE_KEY = 'admin_biz_line'

/* ============================================
 * 类型定义
 * ============================================ */

export type BizLine = 'affiliate' | 'ads' | 'cas'

/** 全部合法业务线取值（localStorage 持久化值需校验，防止历史残留值导致重定向循环） */
const BIZ_LINES: BizLine[] = ['affiliate', 'ads', 'cas']

interface BizLineState {
  bizLine: BizLine
  setBizLine: (bizLine: BizLine) => void
}

/* ============================================
 * Store
 * ============================================ */

function loadStoredBizLine(): BizLine {
  const stored = localStorage.getItem(BIZ_LINE_KEY) as BizLine | null
  return stored && BIZ_LINES.includes(stored) ? stored : 'affiliate'
}

export const useBizLineStore = create<BizLineState>((set) => ({
  bizLine: loadStoredBizLine(),
  setBizLine: (bizLine: BizLine) => {
    localStorage.setItem(BIZ_LINE_KEY, bizLine)
    set({ bizLine })
  },
}))
